import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import ListGroup from 'react-bootstrap/ListGroup'
import FontAwesomeIcon from '@severed-links/common.font-awesome-icon'
import * as s from './DataDeletion.scss'

const DataDeletion = () => {

    const dispatch = useDispatch()
    const userId = useSelector(state => state.account._id)

    useEffect(() => {
    }, [])

    return (
        <Row>
            <Col xs={12} sm={{ span: 10, offset: 1 }} md={{ span: 10, offset: 1 }} lg={{ span: 8, offset: 2 }}>
                <div className={s.container}>
                    <h2>Data Deletion</h2>
                    <p>Our app allows deletion of your data and account (although we may need to retain some identifying information in our records to linked records to prevent app issues). Please log in to your account and submit a help ticket in our Help Center, or submit an email to <a href='mailto:support@redherrings.com'>support@redherrings.com</a>.</p>
                </div>
            </Col>
        </Row>
    )
}

export default DataDeletion
